import { Injectable } from '@angular/core';

import { ApiService } from './api.service';
import { CONSTANTS } from '../../constants';

@Injectable({
  providedIn: 'root'
})
export class BrokerService extends ApiService {

  public getUserBrokers(data: any) {
    return this.getQueryParams(CONSTANTS.API.BROKER.USER_BROKERS, data);
  }
  public addBroker(data: any) {
    return this.post(CONSTANTS.API.BROKER.ADD_BROKER, data);
  }
  public updateBroker(data: any) {
    return this.post(CONSTANTS.API.BROKER.UPDATE_BROKER, data);
  }
  public deleteBroker(data: any) {
    return this.getQueryParams(CONSTANTS.API.BROKER.DELETE_BROKER, data);
  }
  public connectBroker(data: any) {
    return this.getQueryParams(CONSTANTS.API.BROKER.CONNECT_BROKER, data);
  }
  public contractAccountLogin(data: any) {
    return this.getContQueryParams(CONSTANTS.API.BROKER.FEED_ACCOUNT_LOGIN, data);
  }
  public getAllBrokers(data: any) {
    return this.getQueryParams(CONSTANTS.API.BROKER.ALL_BROKERS, data);
  }
}
